import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

/** Light is the DEFAULT (decided 2026-07-11); dark only via explicit toggle.
 *
 *  The icon shows what you will GET, not what you are in — a sun while dark
 *  means "click for light". That is the convention people already have from
 *  every other console, and the alternative reads as a broken toggle. */
export function ThemeToggle() {
  const [dark, setDark] = useState(
    () => document.documentElement.getAttribute("data-theme") === "dark",
  );
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
    try {
      localStorage.setItem("orbit-theme", dark ? "dark" : "light");
    } catch {
      /* private window or blocked storage — the toggle still works this session */
    }
  }, [dark]);
  return (
    <button
      className="iconbtn"
      onClick={() => setDark((d) => !d)}
      aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
      title={dark ? "Light mode" : "Dark mode"}
    >
      {dark ? <Sun size={15} strokeWidth={1.9} /> : <Moon size={15} strokeWidth={1.9} />}
    </button>
  );
}
